import { render, staticRenderFns } from "./WindowHeader.vue?vue&type=template&id=7e0523c0&"
import script from "./WindowHeader.vue?vue&type=script&lang=js&"
export * from "./WindowHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports